import { REQUEST_URL } from "../constants";
import { RequestUtil, RequestFileUtil } from "../utils";
import { VideoInputModel, PaginationQueryModel, VideoFlag } from "../models"

export const VideoService = {
  getFilterVideo,
  getVideo,
  createVideo,
  uploadVideo,
  updateVideo,
  deleteVideo
};

async function getFilterVideo(query: PaginationQueryModel & { languageId: string, flag: VideoFlag, searchValue?: string, urlCategory?: string }) {
  const url = REQUEST_URL.GET_FILTER_ALL_VIDEO;

  return RequestUtil.get({ url, query });
}

async function getVideo(code: string, query?: { languageId?: string }) {
  const url = REQUEST_URL.GET_VIDEO.replace("{CODE}", code);;

  return RequestUtil.get({ url, query });
}

async function createVideo(data: VideoInputModel[]) {
  const url = REQUEST_URL.CREATE_VIDEO;

  return RequestUtil.post({ url, data });
}

async function uploadVideo(formData: FormData) {
  const url = REQUEST_URL.VIDEO.UPLOAD;

  return RequestFileUtil.post({ url, data: formData });
}

async function updateVideo(code: string, data: VideoInputModel[]) {
  const url = REQUEST_URL.UPDATE_VIDEO.replace("{CODE}", code);

  return RequestUtil.put({ url, data });
}

async function deleteVideo(code: string) {
  const url = REQUEST_URL.DELETE_VIDEO.replace("{CODE}", code);

  return RequestUtil.delete({ url });
}